import { useCallback, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import Navbar from "../Navbar.js";
import Ticket from "../ticket/Ticket.js";
import TicketSkeleton from "../skeleton/TicketSkeleton.js";
import { useTicketContext } from "../../context/TicketContext.js";
import Chat from "../chat-message/Chat.js";

const TicketLayout = () => {
  let { id } = useParams();
  const { ticket, loading, getTicketById } = useTicketContext();
  const [width, setWidth] = useState(25);

  const styles = {
    leftPanel: {
      width: `${width}%`,
      cursor: "col-resize",
    },
    rightPanel: {
      width: `${98 - width}%`,
    },
  };

  const dragHandler = useCallback(
    (e) => {
      const w =
        ((e.clientX -
          e.currentTarget.parentElement.parentElement.getBoundingClientRect()
            .left) /
          e.currentTarget.parentElement.parentElement.getBoundingClientRect()
            .width) *
        100;
      if (w > 0 && w !== width) {
        setWidth(w);
      }
    },
    [width]
  );
  useEffect(() => {
    if (id) {
      getTicketById(id);
    }
  }, [id]);

  return (
    <div className="main">
      <Navbar />
      <div className="flex px-10 bg-white">
        <div
          draggable
          onDrag={dragHandler}
          className="w-525 h-screen "
          style={styles.leftPanel}
        >
          <Outlet />
          <Chat />
        </div>

        <div className="contentContainer  bg-white" style={styles.rightPanel}>
          {loading ? <TicketSkeleton /> : <Ticket {...ticket} />}
        </div>
      </div>
    </div>
  );
};

export default TicketLayout;
